import { IStackTokens, mergeStyles, getTheme, IStackItemStyles } from '@fluentui/react';
import heroSVG from '../../assets/hero.svg';

const palette = getTheme().palette;
export const containerTokens: IStackTokens = {
  childrenGap: '3.4375rem'
};
export const upperStackStyle = mergeStyles({
  background: `url(` + heroSVG.toString() + `) no-repeat center`,
  selectors: {
    '@media (max-width: 53.4375rem)': {
      padding: '0.625rem'
    }
  }
});
export const upperStackTokens: IStackTokens = {
  childrenGap: '2.625rem'
};
export const upperStackButtons: IStackTokens = {
  childrenGap: '1.0rem'
};
export const stackItemStyles: IStackItemStyles = {
  root: {
    width: '100%'
  }
};
export const headerStyle = mergeStyles({
  fontWeight: 600,
  fontSize: '2.5rem',
  textAlign: 'center'
});
export const datePickerStyle = mergeStyles({
  width: '100%',
  height: '34.8px'
});
export const liststackItemStyles: IStackItemStyles = {
  root: {
    width: '25%'
  }
};
export const stackBtnItemStyles: IStackItemStyles = {
  root: {
    width: '100%',
    textAlign: 'center',
    marginTop: '1.375rem !important'
  }
};
export const buttonStyle = mergeStyles({
  fontWeight: 600,
  fontSize: '0.875rem', // 14px
  width: '12rem',
  height: '2.5rem',
  borderRadius: 3,
  padding: '0.625rem',
});
export const videoCameraIconStyle = mergeStyles({
  marginRight: '0.375rem',
  fontSize: '1.375rem'
});

export const listItemStyle = mergeStyles({
  paddingLeft: '2em',
  textIndent: '-1em'
});
export const nestedStackTokens: IStackTokens = {
  childrenGap: '0.75rem'
};
export const listStyle = mergeStyles({
  listStyleType: 'none',
  fontSize: '0.875rem',
  margin: 0,
  padding: 0,
  listStylePosition: 'outside'
});
export const iconStyle = mergeStyles({
  marginRight: '0.4375rem',
  color: palette.themePrimary
});
export const imgStyle = mergeStyles({
  width: '27.25rem',
  height: '20.125rem',
  selectors: {
    '@media (max-width: 67.1875rem)': {
      display: 'none'
    }
  }
});
export const dateTextStyle = mergeStyles({
  fontSize: '14px',
  fontWeight: 600,
  color: 'rgb(50, 49, 48)',
  margin: '0px',
  display: 'block',
  padding: '5px 0px',
  overflowWrap: ' break-word',
});
export const dateInputStyle = mergeStyles({
  selectors: {
    'input': {
      fontFamily: '"Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif',
      fontSize: '0.875rem',
      fontWeight: 600,
      boxShadow: 'none',
      margin: '0px',
      padding: '6px 8px',
      boxSizing: 'border-box',
      borderRadius: '0px',
      background: 'none transparent',
      color: 'rgb(50, 49, 48)',
      width: '100%',
      minWidth: '0px',
      textOverflow: 'ellipsis',
      outline: '0px',
      minHeight: 'inherit',
      lineHeight: '1.5rem',
      flexGrow: 1,
      overflow: 'auto',
      border: '1px solid rgb(96, 94, 92)'
    },
  }
});